<ngx-spinner [name]="'erro-cadastro'" type="ball-clip-rotate-pulse" [fullScreen]="false" bdColor="rgba(0, 0, 0, 0.2)">
</ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Erro cadastro cliente (lat/lng)</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <h1 class="customH1">Usuários</h1>
            </div>
            <div class="col-sm">
                <hr />
            </div>
        </div>

        <div class="row mt-2" >
            <div class="col-sm">
                <table mat-table [dataSource]="clientesSource" class="mat-elevation-z2" >

                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Descrição (Nome) </th>
                        <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Email">
                        <th mat-header-cell *matHeaderCellDef> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Cidade">
                        <th mat-header-cell *matHeaderCellDef> Cidade </th>
                        <td mat-cell *matCellDef="let element"> {{element.Cidade}} </td>
                    </ng-container>


                    <ng-container matColumnDef="Consultar">
                        <th mat-header-cell *matHeaderCellDef> Consultar </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Expandir" (click)="consultarCliente(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Expandir">search</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="consultarCliente(row)"></tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6" style="text-align: center;">Não há cadastros sem latitude ou
                            longitude no sistema
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 15, 20, 25, 50, 100, 200]"></mat-paginator>
            </div>
        </div>

        <!-- <div class="borda">
            <div class="row">
                <div class="col-sm">
                    <div style="margin: 5px;">{{arrayIDClientesNome}}</div>
                </div>
            </div>
        </div> -->

        <!-- <div class="row mt-4">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
                    <button mat-flat-button color="primary" (click)="validarEstoque()">
                        <mat-icon>check</mat-icon> Validar estoque
                    </button>
                </section>
            </div>
        </div> -->
    </mat-card-content>

    <!-- <mat-card-content *ngIf="arrayIDClientesNome.length === 0">
        <div class="row">
            <div class="col-sm">
                <div style="margin: 5px;">Não há cadastros sem latitude ou longitude no sistema;</div>
            </div>
        </div>
    </mat-card-content> -->

</mat-card>